import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import LeadsDashboard from "@/pages/LeadsDashboard";
import LegalPage from "@/pages/LegalPage";
import DownloadWelcome from "@/pages/DownloadWelcome";
import Offer from "@/pages/Offer";
import FreeMeditation from "@/pages/FreeMeditation";
import TopUp from "@/pages/TopUp";
import { setLenis } from "@/lib/lenisScroll";

function App() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/leads" element={<LeadsDashboard />} />
          <Route path="/download" element={<DownloadWelcome />} />
          <Route path="/offer" element={<Offer />} />
          <Route path="/meditation" element={<FreeMeditation />} />
          <Route path="/topup" element={<TopUp />} />
          <Route path="/:slug" element={<LegalPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
